<!--  -->
<template>
    <div class="success">
        <div class="success-container">
            <div class="success-icon">
                <svg viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" fill="#f0d8d8" stroke="none" />
                    <path fill="none" stroke="red" stroke-width="6" stroke-linecap="round"
                        stroke-linejoin="round" d="M30 30 L70 70 M70 30 L30 70" style="stroke-dasharray: 100;
                 stroke-dashoffset: 100;
                 animation: checkmark 0.8s ease-out forwards;
                 animation-delay: 0.3s" />
                </svg>
            </div>
            <h1 class="success-title">问卷已关闭！</h1>
            <div class="action-buttons">
                <a href="https://www.bjia.org/" class="btn">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    返回首页
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'success',
        data() {
            //这里存放数据
            return {

            }
        },
        components: {},

        //方法集合
        methods: {
            beforeDestroy() {
                // 在组件销毁时移除 meta 标签
                const meta = document.querySelector('meta[name="viewport"]');
                if (meta) {
                    document.head.removeChild(meta);
                }
            }
        },
        created() {

        },
        mounted() {
             document.title='调查问卷'
            const meta = document.createElement('meta');
            meta.name = 'viewport';
            meta.content = 'width=device-width, initial-scale=1.0, user-scalable=no';
        }
    }
</script>
<style>
    :root {
        --primary: #4179d2;
        --light-bg: #f8f9fc;
    }

    .success {
        max-width: 100vw;
        margin: 0;
        min-height: 100vh;
        display: flex;
        align-items: center;
        background: var(--light-bg);
        font-family: 'Microsoft YaHei', sans-serif;
    }

    .success-container {
        width: 80vw;
        margin: 0.5rem auto;
        padding: 0.5rem;
        text-align: center;
        background: white;
        border-radius: 30px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
        position: relative;
    }

    .success-icon {
        width: 3rem;
        height: 3rem;
        margin: 0.6rem auto;
        animation: float 3s ease-in-out infinite;
    }

    @keyframes float {

        0%,
        100% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-8px);
        }
    }

    @keyframes checkmark {
        from {
            stroke-dashoffset: 100;
        }

        to {
            stroke-dashoffset: 0;
        }
    }

    .success-title {
        text-align: center;
        font-size: 0.6rem;
        padding-left: 0.5rem;
        color: #e41f1f;
        font-weight: 600;
    }

    .success-message {
        color: #616161;
        font-size: 0.4rem;
        line-height: 0.55rem;
        margin: 0 auto 0.3rem;
        /* max-width: 480px; */
    }

    .action-buttons {
        display: flex;
        justify-content: center;
    }

    .btn {
        padding: 0.3rem 0.6rem;
        /* padding: 0.9rem 2.5rem; */
        border-radius: 8px;
        text-decoration: none;
        font-weight: 500;
        transition: all 0.2s;
        background: var(--primary);
        color: white;
        box-shadow: 0 4px 14px rgba(65, 121, 210, 0.3);
        border: none;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(65, 121, 210, 0.4);
    }
</style>